import { loginPhases } from "components/web-checkout/login-card/login-card.data";
import { constants } from "constants/constants";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { setLocalStorage } from "services/local-storage";
import { useAuth } from "stores/auth/auth-context";
import { isObjectEmpty } from "utils/utils";
import { IUseLogin, IUseLoginProps } from "./use-login.types";

const useLogin = ({ documentReferrer }: IUseLoginProps = {}): IUseLogin => {
  const {
    user,
    user: { isUserLoggedIn }
  } = useAuth();
  const router = useRouter();
  const routerPath = router.pathname;

  const [prevLink, setPrevLink] = useState("/");
  useEffect(() => {
    if (!isObjectEmpty(user.userData)) {
      router.push({
        pathname: "/auth-redirect",
        query: router.query
      });
    } else {
      const loggedInFrom =
        documentReferrer && documentReferrer.length > 0
          ? documentReferrer
          : window?.location.origin ||
            (process.env.NEXT_PUBLIC_SITE_URL as string);
      setLocalStorage(constants.LOGGED_IN_FROM_PAGE, {
        href: loggedInFrom
      });
      setPrevLink(loggedInFrom);
    }
    return;
  }, []);

  const [formPhase, setFormPhase] = useState(loginPhases.generateOTP);

  return {
    isUserLoggedIn,
    routerPath,
    setFormPhase,
    formPhase,
    prevLink
  };
};

export { useLogin };
